import React, { useState } from "react";
import { BracketsSquare } from "@phosphor-icons/react";
import { useAgentsSidebarContext, FluxObject } from "./context";
import { Item } from "./Item";
import { ActionMenu } from "./ActionMenu";

interface FluxBotItemProps {
  object: FluxObject;
  onEdit?: (object: FluxObject) => void;
  onRename?: (object: FluxObject) => void;
  onDelete?: (object: FluxObject) => void;
  isNested?: boolean;
}

export const FluxBotItem: React.FC<FluxBotItemProps> = ({
  object,
  onEdit,
  onRename,
  onDelete,
  isNested = true,
}) => {
  const { activeObjectId, onObjectClick } = useAgentsSidebarContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Item
        icon={<BracketsSquare size={16} />}
        label={object.name}
        isActive={activeObjectId === object.id}
        isNested={isNested}
        onClick={() => onObjectClick(object)}
        onMenuClick={handleMenuClick}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onEdit={onEdit ? () => onEdit(object) : undefined}
        onRename={onRename ? () => onRename(object) : undefined}
        onDelete={onDelete ? () => onDelete(object) : undefined}
        showEdit={true}
      />
    </>
  );
};
